import React, { useEffect, useState } from "react";
import {
  Box,
  IconButton,
  MenuItem,
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TextField,
  Typography,
  Button,
} from "@mui/material";
import { Edit, Delete, Visibility } from "@mui/icons-material";
import apiClient from "../utils/apiClient";
import { toast } from "react-toastify";
import ConfirmDialog from "../components/ConfirmDialog";
import FallbackImage from "../components/FallbackImage";
import { getImageFullUrl, pageRoute } from "../utils/common";
import { useNavigate } from "react-router-dom";
import CategoryBannerDialog from "./CategoryBannerAdd";

const CategoryBannerList = () => {
  const [products, setProducts] = useState([]);

  const [loading, setLoading] = useState(false);

  // ✅ Confirm dialog state
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deleteData, setDeleteData] = useState({});
  const [selectData, setSelectData] = useState({});

  const [open, setOpen] = useState(false);

  // ✅ Show confirm dialog before delete
  const requestDelete = (data) => {
    setDeleteData(data);
    setConfirmOpen(true);
  };

  const navigate = useNavigate()

  const pageChange = (url) => {
    navigate(url)
  }

  // Fetch products
  const fetchProducts = async () => {
    try {
      setLoading(true);
      const res = await apiClient.get("/api/category-banner");

      setProducts(res?.data?.data || []);
    } catch (err) {
      toast.error("Failed to load category banner");
    } finally {
      setLoading(false);
    }
  };

  // Refetch when filters/search/page/rowsPerPage change
  useEffect(() => {
    fetchProducts();
  }, []);

  // Toggle status
  const handleStatusChange = async (id, newStatus) => {
    try {
      await apiClient.put(`/api/category-banner/${id}`, { status: newStatus });
      toast.success("Status updated");
      fetchProducts();
    } catch {
      toast.error("Failed to update status");
    }
  };

  // Delete product
  const handleDelete = async (id) => {
    try {
      await apiClient.delete(`/api/category-banner/${id}`);
      toast.success("Category Banner deleted");
      fetchProducts();
    } catch {
      toast.error("Failed to delete Category Banner");
    }
  };

  return (
    <Paper sx={{ p: 3 }}>
      <Box sx={{ display: "flex", gap: 2, mb: 2, flexWrap: "wrap", alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant="h5" gutterBottom>
          Category Banner List
        </Typography>
        <Button variant="outlined" onClick={() => {
          setSelectData({})
          setOpen(true)
        }}>
          Add Category Banner
        </Button>
      </Box>

      {/* Table */}
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Image</TableCell>
              <TableCell>Category </TableCell>
              <TableCell>Sub Category </TableCell>
              <TableCell>Third Sub Category </TableCell>
              <TableCell>Status</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {products.length > 0 ? (
              products.map((row) => (
                <TableRow key={row.id}>
                  <TableCell><FallbackImage
                    src={getImageFullUrl(row.images)}
                    style={{ maxHeight: '50px' }}
                  /></TableCell>
                  <TableCell>{row.categoryName}</TableCell>
                  <TableCell>{row.subCategoryName}</TableCell>
                  <TableCell>{row.thirdSubCategoryName}</TableCell>
                  <TableCell>
                    <Switch
                      checked={row.status === "active"}
                      onChange={(e) =>
                        handleStatusChange(
                          row.id,
                          e.target.checked ? "active" : "inactive"
                        )
                      }
                    />
                  </TableCell>
                  <TableCell align="center">
                   
                    <IconButton
                      color="secondary"
                      onClick={() => {
                        setSelectData(row)
                        setOpen(true)
                      }}
                    >
                      <Edit />
                    </IconButton>
                    <IconButton
                      color="error"
                      // onClick={() => handleDelete(row.id)}
                      onClick={() => requestDelete(row)}
                    >
                      <Delete />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={7} align="center">
                  {loading ? "Loading..." : "No Banner found"}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <ConfirmDialog
        open={confirmOpen}
        title={`Delete Category Banner`}
        content="Are you sure you want to delete this Category Banner?"
        onClose={() => setConfirmOpen(false)}
        onConfirm={() => {
          handleDelete(deleteData?.id)
          setConfirmOpen(false)
        }}
      />
      <CategoryBannerDialog open={open} onClose={() => setOpen(false)} onSaved={() => {
        setOpen(false)
        fetchProducts()
      }}
        editData={selectData}
      />
    </Paper>
  );
};

export default CategoryBannerList;
